module.exports = __webpack_public_path__ + "img/award_border.a5054218.png";